import { AeBoxAnchor, AeBoxVersion } from 'src/models/anchor-and-version/ae-box.model';
import { Injectable, inject } from '@angular/core';
import { AnchorAndVersionBaseService } from './anchor-and-version-base.service';
import { AuthService } from '../auth.service';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class AeBoxService extends AnchorAndVersionBaseService<AeBoxAnchor, AeBoxVersion> {
    protected authService = inject(AuthService);
    protected baseUrl = '/api/aebox';
    protected http = inject(HttpClient);
    protected store = inject<Store<{ config: ConfigState }>>(Store);
}
